
// Function to set start of day and end of day for given date
const setStartOfDay = (date: Date) => {
    date.setHours(0, 0, 0, 0);
    return date.toISOString();
};

const setEndOfDay = (date: Date) => {
    date.setHours(23, 59, 59, 999);
    return date.toISOString();
};


const advanceprocessFilterDateType = (filters: any): any => {
    if (Array.isArray(filters)) {
        // Case: top-level is an array of filters
        return filters.map((filter: any) => advanceprocessFilterDateType(filter));
    }

    if (filters?.filters && Array.isArray(filters.filters)) {
        // Case: filters contain nested filters
        return {
            ...filters,
            filters: filters.filters.map((f: any) => advanceprocessFilterDateType(f))
        };
    }

    // Case: actual filter with dateType to process
    if (filters?.dateType) {
        const today = new Date();
        let value = null;
        let highValue = null;

        switch (filters.dateType.value) {
            case 'today':
                value = setStartOfDay(today);
                highValue = setEndOfDay(today);
                break;
            case 'yesterday':
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                value = setStartOfDay(yesterday);
                highValue = setEndOfDay(yesterday);
                break;
            case 'this_week':
                const startOfWeek = new Date(today);
                startOfWeek.setDate(today.getDate() - today.getDay());
                value = setStartOfDay(startOfWeek);
                highValue = setEndOfDay(today);
                break;
            case 'last_week':
                const startOfLastWeek = new Date(today);
                startOfLastWeek.setDate(today.getDate() - today.getDay() - 7);
                value = setStartOfDay(startOfLastWeek);
                const endOfLastWeek = new Date(startOfLastWeek);
                endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
                highValue = setEndOfDay(endOfLastWeek);
                break;
            case 'this_month':
                value = setStartOfDay(new Date(today.getFullYear(), today.getMonth(), 1));
                highValue = setEndOfDay(new Date(today.getFullYear(), today.getMonth() + 1, 0));
                break;
            case 'last_month':
                value = setStartOfDay(new Date(today.getFullYear(), today.getMonth() - 1, 1));
                highValue = setEndOfDay(new Date(today.getFullYear(), today.getMonth(), 0));
                break;
            case 'specific_date':
                value = setStartOfDay(new Date(filters.value));
                highValue = setEndOfDay(new Date(filters.highValue || filters.value));
                break;
            default:
                value = filters.value;
                highValue = filters.highValue;
        }

        return {
            ...filters,
            value,
            highValue,
            condition:'BETWEEN',
            conditionLabel: 'is between'
        };
    }

    // Default case: return filter unchanged
    return filters;
};


export default advanceprocessFilterDateType;
